<template>
  <div class="selectCopy-container">
    <van-nav-bar :title="title" left-arrow @click-left="onClickLeft" />
    <div
      class="search-member"
      v-if="
        status.slice(0, 4) !== 'posi' &&
        status.slice(0, 4) !== 'depa' &&
        status.slice(0, 4) !== 'comp'
      "
    >
      <van-search v-model="value" placeholder="搜索" show-action @input="search" />
    </div>
    <div class="member-max">最多选择一百人</div>
    <div class="member-box" v-show="visible">
      <!-- <a-tree
        v-model="checkedKeys"
        checkable
        :auto-expand-parent="autoExpandParent"
        :tree-data="memberList"
        @check="onCheck"
        :replaceFields="{
          title: 'name',
          key: 'id',
          children: 'childList',
        }"
      /> -->
      <Tree :model="memberList[0]" />
    </div>
    <div class="search-list" v-show="!visible">
      <div
        v-for="(item, index) in searchList"
        :key="index"
        class="item-list"
        @click="handleClick(item)"
      >
        <!-- <img v-if="item.check" style="width: .4rem;height: .4rem;" src="../assets/radio.png"/>
          <img v-else style="width: .4rem;height: .4rem;" src="../assets/radioCheck.png"/>
          <img style="width: .8rem;height: .8rem; margin-left: .2rem; margin-right: .2rem" v-if="item.avatar" :src="item.avatar">
          <van-icon name="map-marked" v-else />
          <span>{{item.staffName}}</span> -->
        <div
          style="
            width: 90vw;
            display: flex;
            height: 128px;
            background: #ffffff;
            border-radius: 8px;
          "
        >
          <div class="clickbox">
            <img
              v-if="item.check"
              style="width: 0.4rem; height: 0.4rem"
              src="../assets/blank.png"
            />
            <img v-else style="width: 0.4rem; height: 0.4rem" src="../assets/Check.png" />
          </div>
          <div class="concentbox">
            <div style="border-bottom: 1px solid #f3f3f3; min-height: 7vh; display: flex">
              <div style="padding-top: 0.4rem">
                <img
                  style="
                    width: 0.8rem;
                    height: 0.8rem;
                    margin-left: 0.2rem;
                    margin-right: 0.2rem;
                  "
                  v-if="item.avatar"
                  :src="item.avatar"
                />
                <van-icon
                  style="
                    width: 0.8rem;
                    height: 0.8rem;
                    margin-left: 0.2rem;
                    margin-right: 0.2rem;
                  "
                  name="map-marked"
                  v-else
                />
              </div>
              <div style="padding-top: 0.2rem">
                <p>{{ item.name }}</p>
                <p>{{ item.phone }}</p>
              </div>
            </div>
            <div>
              <div class="title">公司名称：{{ item.companyName }}</div>
              <div class="title">部门名称：{{ item.officeName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <span style="color: #54b2ed; padding-left: 0.4rem"
        >已选{{
          selectedList.hasOwnProperty(`${status}`) ? selectedList[`${status}`].length : 0
        }}/100</span
      >
      <van-button type="info" style="margin-right: 0.4rem" @click="onConfirm"
        >确定</van-button
      >
    </div>
  </div>
</template>
<script>
import { getAddressBook, getJobList, getOfficeList } from "@/axios/services";
import { mapState } from "vuex";
import Tree from "../commonComponents/TreeAddressBook.vue";
export default {
  components: {
    Tree,
  },
  data() {
    return {
      value: "",
      memberList: [],
      autoExpandParent: true,
      checkedKeys: [],
      visible: true,
      searchList: [],
      title: "",
    };
  },
  watch: {
    value(val) {
      if (val === "") {
        this.visible = true;
      }
    },
  },
  computed: {
    ...mapState(["selectedList", "status", "initialData", "kitValue", "applyCompanyId"]),
  },
  mounted() {
    if (this.status.slice(0, 4) === "posi") {
      this.title = "岗位选择";
    } else if (this.status.slice(0, 4) === "depa") {
      this.title = "部门选择";
    } else if (this.status.slice(0, 4) === "comp") {
      this.title = "公司选择";
    } else {
      this.title = "人员选择";
    }
    if (this.status.slice(0, 4) === "posi") {
      getJobList(this.initialData.companyId).then((res) => {
        let arr = [];
        arr.push({
          name: "请选择",
          level: -2,
          childList: this.handleOptions(res.data.data),
        });
        this.memberList = arr;
      });
    } else if (this.status.slice(0, 4) === "depa") {
      const params = {
        companyId: this.applyCompanyId || this.initialData.companyId,
      };
      getOfficeList(params).then((res) => {
        let arr = [];
        arr.push({
          name: "请选择",
          level: 0,
          childList: this.handleOptions(res.data.data),
        });
        this.memberList = arr;
      });
    } else if (this.status.slice(0, 4) === "comp") {
      const params = {
        activeState: 0,
        companyId: this.initialData.companyId,
        jobStatus: 0,
        operationalPermissions: 0,
        allShowView: 0,
        returnType: 0,
      };
      getAddressBook(params).then((res) => {
        if (res.data.code === 0) {
          this.memberList = this.handleOptions(res.data.data);
        }
      });
    } else {
      this.getMemeberList();
    }
  },
  methods: {
    handleClick(item) {
      this.searchList.map((i) => {
        if (i.staffId === item.staffId) {
          i.check = !i.check;
          this.checkedKeys =
            i.check === true
              ? this.checkedKeys?.filter((item) => item !== i.staffId)
              : (this.checkedKeys || []).concat([item.staffId]);
          this.$store.commit("setCheckedList", {
            data: item,
            status: i.check,
            number: this.status,
          });
        }
      });
      // this.visible = true;
      // this.value = "";
      this.getMemeberList();
    },
    getMemeberList() {
      getAddressBook({
        activeState: 0,
        companyId: this.initialData.companyId,
        jobStatus: 0,
        operationalPermissions: 0,
        allShowView: 0,
        returnType: 0,
      }).then((res) => {
        this.memberList = this.handleOptions(res.data.data);
        this.checkedKeys = this.selectedList[`${this.status}`]?.map(
          (item) => item.staffId
        );
      });
    },
    onClickLeft() {
      //从审批进去选择抄送人
      const instanceId = localStorage.getItem("instanceId");
      if (instanceId != null) {
        this.$router.push({
          path: "/approve-form",
          query: {
            instanceId: instanceId,
          },
        });
        //跳转清空
        localStorage.removeItem("instanceId");
      } else {
        window.history.back();
      }
      //this.$router.back();
    },
    search() {
      if (!this.value) return;
      this.visible = false;
      const params = {
        companyId: this.initialData.companyId,
        searchKey: this.value,
        returnType: 1,
        activeState: 0,
        allShowView: 0,
        operationalPermissions: 0,
      };
      getAddressBook(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data.map((item) => ({
            ...item,
            check: true,
            staffId: item.id,
            staffName: item.name,
          }));
          this.checkedKeys = this.selectedList[`${this.status}`]?.map(
            (item) => item.staffId
          );
          data.map((item) => {
            if (this.checkedKeys?.includes(item.staffId)) {
              item.check = false;
            }
          });
          this.searchList = data;
        }
      });
    },
    onCheck() {
      // this.checkedKeys = checkedKeys;
      // const data = e.checkedNodes.map((item) => item.data.props.dataRef);
      // this.$store.commit("setSelectedList", data);
    },
    handleOptions(item) {
      if (this.status.slice(0, 4) === "posi") {
        return this.handlePushPosition(item);
      } else if (this.status.slice(0, 4) === "depa") {
        return this.handlePushDepartment(item);
      } else if (this.status.slice(0, 4) === "comp") {
        return this.handleCompanyOptions(item);
      } else {
        return this.handlePushPerson(item);
      }
    },
    handleCompanyOptions(item) {
      let that = this;
      function handlePushText(item) {
        for (let i = 0, len = item.length; i < len; i++) {
          let childList = item[i].childList;
          if (item[i].type !== 0 && item[i].type !== 3) {
            item[i].checkable = false;
          }
          if (that.selectedList[`${that.status}`]?.length > 0) {
            that.selectedList[`${that.status}`].map((items) => {
              if (items.id === item[i].id) {
                item[i].isChecked = true;
              }
            });
          }
          if (childList && childList.length > 0) {
            handlePushText(childList);
          }
        }
        return item;
      }
      return handlePushText(item);
    },
    handlePushPerson(item) {
      let that = this;
      for (let i = 0, len = item.length; i < len; i++) {
        let childList = item[i].childList;
        item[i].staffId = item[i].id;
        item[i].staffName = item[i].name;
        if (item[i].type !== 2) {
          item[i].checkable = false;
        }
        if (that.selectedList[`${that.status}`]?.length > 0) {
          that.selectedList[`${that.status}`].map((items) => {
            if (items.id === item[i].id) {
              item[i].isChecked = true;
            }
          });
        }
        if (childList && childList.length > 0) {
          this.handlePushPerson(childList);
        }
      }
      return item;
    },
    handlePushPosition(item) {
      let that = this;
      for (let i = 0, len = item.length; i < len; i++) {
        let childList = item[i].list;
        item[i].childList = item[i].list;
        if (that.selectedList[`${that.status}`]?.length > 0) {
          that.selectedList[`${that.status}`].map((items) => {
            if (items.id === item[i].id) {
              item[i].isChecked = true;
            }
          });
        }
        if (childList && childList.length > 0) {
          this.handlePushPosition(childList);
        }
      }
      return item;
    },
    handlePushDepartment(item) {
      let that = this;
      for (let i = 0, len = item.length; i < len; i++) {
        let childList = item[i].childList;
        item[i].name = item[i].officeName;
        item[i].level = item[i].level === 3 ? 2 : item[i].level;
        item[i].id = item[i].officeId;
        if (that.selectedList[`${that.status}`]?.length > 0) {
          that.selectedList[`${that.status}`].map((items) => {
            if (items.id === item[i].id) {
              item[i].isChecked = true;
            }
          });
        }
        if (childList && childList.length > 0) {
          this.handlePushDepartment(childList);
        }
      }
      return item;
    },
    onConfirm() {
      //从审批进去选择抄送人
  
      const instanceId = localStorage.getItem("instanceId");
      if (instanceId != null) {
        this.$router.push({
          path: "/approve-form",
          query: {
            instanceId: instanceId,
          },
        });
        //跳转清空
        localStorage.removeItem("instanceId");
      } else {
        window.history.back();
      }

      //this.$router.back();
    },
  },
};
</script>
<style scoped>
.selectCopy-container {
  width: 100vw;
  min-height: 100vh;
  background: #f9f9f9;
  padding-bottom: 10vh;
}
.member-max {
  height: 0.45rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.55rem;
  margin-left: 0.37rem;
}
.member-box {
  /* width: 100vw;
    font-size: 16px; */
  width: 92%;
  margin: 0.4rem;
  margin-top: 0.27rem;
  border-radius: 8px;
  background: white;
  font-size: 16px;
  padding: 0.43rem;
}
.search-list {
  width: 90vw;
  /* background: white; */
  min-height: 40vh;
  margin: 0.2rem auto;
  /* padding-left: 0.2rem; */
}
.item-list {
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
}
.footer {
  width: 100vw;
  height: 10vh;
  background: white;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px -2px 4px 0px #efefef;
}
.clickbox {
  width: 1rem;
  padding: 0.3rem;
  margin-right: 0.2rem;
  padding-top: 0.5rem;
}
.concentbox {
  width: 89vw;
}
p {
  margin-bottom: 0 !important;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  /* margin-top: 0.1rem; */
}
.title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-top: 0.15rem;
}
</style>
